(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bzk-stock-sale"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-stock-sort]')) return;
    var section = event.target.closest('[data-bzk-stock-sale]');
    var grid = section.querySelector('[data-stock-grid]');
    var cards = Array.from(grid.querySelectorAll('[data-stock-card]'));
    var value = event.target.value;
    cards.sort(function (a, b) {
      if (value === 'price-ascending') return Number(a.dataset.stockPrice) - Number(b.dataset.stockPrice);
      if (value === 'price-descending') return Number(b.dataset.stockPrice) - Number(a.dataset.stockPrice);
      return Number(a.dataset.stockPosition) - Number(b.dataset.stockPosition);
    });
    cards.forEach(function (card) { grid.appendChild(card); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bzk-desktop-hero-video')) {
    customElements.define('bzk-desktop-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.desktopQuery = window.matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');
        this.updateVideo = () => {
          const video = this.querySelector(':scope > video');
          if (this.desktopQuery.matches) {
            if (!video) this.append(this.querySelector('template').content.cloneNode(true));
          } else if (video) {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.load();
            video.remove();
          }
        };
        this.desktopQuery.addEventListener('change', this.updateVideo);
        this.updateVideo();
      }

      disconnectedCallback() {
        this.desktopQuery.removeEventListener('change', this.updateVideo);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
